/**
 * Patron 1:
 *   - Se utilizá cuando lo único que se busca es conseguir un dato
 *   - Debería reemplazar a los shows simples que no tienen acciones
 */
const defaultStateSubrequest = {
    data: null,
    loading: false,
    error: null,
    loaded: false,
    success: false,
};
const defaultState = {
    data: null,
    timestamp: null,
    loading: false,
    error: null,
    success: false,
    loaded: false,
    subrequest: defaultStateSubrequest,
};

const main = (section) => (state = defaultState, action) => {
    switch (action.type) {
        case `${section}_REQUEST_SUCCESS`:
            return {
                ...state,
                loading: false,
                error: null,
                data: action.data,
                timestamp: Date.now().valueOf() / 1000,
                subrequest: defaultStateSubrequest,
                loaded: true,
            };
        case `${section}_REQUEST_LOADING`:
            return {
                ...state,
                error: null,
                loading: true,
                loaded: false,
            };

        case `${section}_REQUEST_ERROR`:
            return {
                ...state,
                error: action.error,
                loading: false,
            };

        case `${section}_SECONDARY_REQUEST_SUCCESS`:
            return {
                ...state,
                subrequest: {
                    success: true,
                    loading: false,
                    error: null,
                    data: action.data,
                },
            };
        case `${section}_SECONDARY_REQUEST_LOADING`:
            return {
                ...state,
                subrequest: {
                    ...state.subrequest,
                    error: null,
                    loading: true,
                    success: false,
                },
            };

        case `${section}_SECONDARY_REQUEST_ERROR`:
            return {
                ...state,
                subrequest: {
                    ...state.subrequest,
                    error: action.error,
                    loading: false,
                    success: false,
                },
            };

        case `${section}_SECONDARY_REQUEST_RESET`:
            return {
                ...state,
                subrequest: defaultStateSubrequest,
            };

        case `${section}_REQUEST_RESET`:
            return defaultState;

        case "CONFIG_SESSION_RESET":
            return defaultState;

        default:
            return state;
    }
};

export default main;
